module.exports = __webpack_public_path__ + "static/media/onboarding-username.6c7ba87a.png";